import React from 'react';
import { useLottie } from 'lottie-react';
import aiLoaderBlack from '../assets/AI-loader-black.json';
import aiLoaderOrange from '../assets/AI-loader-orange.json';
import aiLoaderWhite from '../assets/AI-loader-white.json';

type LoaderColor = 'brand' | 'black' | 'white';

interface LoadingAnimationProps {
  color?: LoaderColor;
  size?: number;
}

const animationByColor: Record<LoaderColor, unknown> = {
  brand: aiLoaderOrange,
  white: aiLoaderWhite,
  black: aiLoaderBlack,
};

export const LoadingAnimation: React.FC<LoadingAnimationProps> = ({
  color = 'brand',
  size = 20,
}) => {
  const animationData = animationByColor[color];

  const { View } = useLottie({ animationData, loop: true }, { height: size });

  return View;
};
